<template>
    <div>
        <transition appear appear-active-class="fade-enter-active" leave-active-class="fade-leave-active">
            <div>
                <p>Il est imp&eacute;ratif d&#39;informer vos prestataires de comment vous utilisez l&#39;information
                    recueillie dans le cadre de votre campagne de mise &agrave; jour. Le p&eacute;rim&egrave;tre
                    juridique d&eacute;finissant ce cadre doit nous &ecirc;tre fourni ici.</p>

                <p>
                    Ce document est présenté et accepté via les formulaires de validation. Il est ensuite envoyé au
                    prestataire en pièce jointe de l'e-mail de remerciement de leur réponse.
                </p>

                <p>Si vous ne poss&eacute;dez pas un tel document, nous vous encourageons &agrave; vous faire
                    accompagner par une structure sp&eacute;cialis&eacute;e.
                    Autrement, vous pouvez vous appuyer sur le travail r&eacute;alis&eacute; par le r&eacute;seau Apidae
                    et ajouter ici le document pr&eacute;sent&eacute; sur cette <a
                        href="https://aide.apidae-tourisme.com/hc/fr/articles/360016788691-Conditions-d-adh%C3%A9sion-Apidae-pour-les-socio-professionnels-et-fournisseurs-d-information"
                        target="_blank">page</a>.</p>

                <p>Documents exemples :</p>

                <ul>
                    <li><a :href="publicPath + 'documents/cgu-grenoble.pdf'" target="_blank">Office de Tourisme
                            Grenoble</a></li>
                    <li><a :href="publicPath + 'documents/cgu-hyeres.pdf'" target="_blank">Office de Tourisme Provence
                            Méditerranée</a></li>
                    <li><a :href="publicPath + 'documents/cgu-passy.pdf'" target="_blank">Office de Tourisme de
                            Passy</a></li>
                    <li><a :href="publicPath + 'documents/cgu-chambery.pdf'" target="_blank">Grand Chambéry Alpes
                            Tourisme</a></li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "CguField",
    data() {
        return {
            publicPath: process.env.BASE_URL
        }
    },
}
</script>
